import forEach from 'lodash/forEach';
import isUndefined from 'lodash/isUndefined';
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import Carousel from '@spothero/ui/carousel';
import CarouselPage from '@spothero/ui/carousel-page';
import CarouselPaginator from '@spothero/ui/carousel-paginator';
import CarouselSlide from '@spothero/ui/carousel-slide';
import CarouselSlides from '@spothero/ui/carousel-slides';
import Image from 'common/image/Image';
import DOMUtils from '@spothero/utils/dom';

export default class SpotImagesDesktop extends Component {
    static propTypes = {
        images: PropTypes.array.isRequired,
        alt: PropTypes.string,
        showThumbnails: PropTypes.bool,
        width: PropTypes.number,
        height: PropTypes.number,
    };
    static defaultProps = {
        showThumbnails: true,
        width: 264,
        height: 232,
    };

    componentDidMount() {
        const {images, showThumbnails} = this.props;

        if (!showThumbnails || images.length < 2) {
            return;
        }

        const numItems = images.length < 3 ? 3 : images.length;
        const items = DOMUtils.el('.SpotImages .item');
        const itemWidth = `${100 / numItems - 2 + 2 / numItems}%`;

        forEach(items, item => {
            item.style.width = itemWidth;
        });

        this._thumbnails.style.opacity = 1;
    }

    _setCarouselPaginatorContainerNode = node => {
        this._thumbnails = node;
    };

    render() {
        const {images, alt, showThumbnails, width, height} = this.props;

        return (
            <div className="SpotImages">
                {images.length > 0 && (
                    <Carousel transition="none">
                        <CarouselSlides>
                            {images.map(image => {
                                return (
                                    <CarouselSlide key={image.id}>
                                        <Image
                                            cloudinaryTemplate={
                                                image.url_template
                                            }
                                            width={width}
                                            height={height}
                                            alt={alt}
                                        />
                                    </CarouselSlide>
                                );
                            })}
                        </CarouselSlides>
                        {showThumbnails && images.length > 1 && (
                            <CarouselPaginator
                                className="thumbnails"
                                containerRef={
                                    this._setCarouselPaginatorContainerNode
                                }
                            >
                                {images.map((image, index) => {
                                    const hasUrlTemplate = !isUndefined(
                                        image.url_template
                                    );
                                    const thumbProps = {
                                        width: 208,
                                        height: 184,
                                        alt: !hasUrlTemplate ? image.alt : alt,
                                        ...(hasUrlTemplate
                                            ? {
                                                  cloudinaryTemplate:
                                                      image.url_template,
                                                  width,
                                                  height,
                                              }
                                            : {src: image.src}),
                                    };

                                    return (
                                        <CarouselPage
                                            key={index}
                                            className="item"
                                        >
                                            <Image {...thumbProps} />
                                        </CarouselPage>
                                    );
                                })}
                            </CarouselPaginator>
                        )}
                    </Carousel>
                )}
            </div>
        );
    }
}
